import { Link } from "react-router-dom";
import { Reveal, SectionHead } from "@/components/site/motion";

export function AboutPreview() {
  return (
    <section id="about" className="section-border-top" data-testid="about-section">
      <div className="wrap">
        <SectionHead
          chapter="Chapter 05"
          kicker="About"
          title="15+ years, different markets, one repeatable playbook."
          testid="about"
        />
        <div className="about-preview">
          <Reveal y={26}>
            <div className="portrait-frame" data-testid="about-portrait-card">
              <img src="/assets/rhonda-johnson-headshot.jpg" alt="Portrait of Rhonda Johnson" />
            </div>
          </Reveal>
          <Reveal y={26} delay={0.12}>
            <p>
              I’ve built and rebuilt partner programs at a Vista Equity portfolio company, a mortgage fintech, a data
              and risk platform, and a tax resolution firm, entering each without prior vertical experience and leaving
              measurable results behind.
            </p>
            <Link to="/about" className="btn btn-ghost" data-testid="about-preview-link" style={{ marginTop: "0.4rem" }}>
              Read the full story <span className="btn-arrow">→</span>
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
}

export function FinalCTA() {
  return (
    <section className="cta-band" data-testid="final-cta-section">
      <div className="wrap">
        <Reveal y={26}>
          <span className="kicker" style={{ color: "var(--brass-bright)" }}>
            <span className="chapter" style={{ color: "var(--brass)" }}>Chapter 06</span>
            Start the conversation
          </span>
          <h2>Let’s talk about what your partnerships could be producing.</h2>
          <p>
            Most conversations start with a specific problem: a stalled channel, a program with no visibility, or a
            Board asking whether to build or partner. Bring that problem, and we’ll work out whether fractional
            leadership is the right next step.
          </p>
          <div className="btn-row">
            <Link to="/contact" className="btn btn-on-ink" data-testid="final-cta-primary">
              Discuss a Partnership Challenge <span className="btn-arrow">→</span>
            </Link>
            <Link to="/about" className="btn btn-ghost-on-ink" data-testid="final-cta-secondary">
              Learn More About Rhonda
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
